/**
 * Auto-generated question texts that impact registration fee calculation.
 *
 * These questions are automatically created by the backend when specific fee
 * structures are configured. Changing the text of these questions may break
 * fee calculations.
 *
 * This structure must match the backend structure in:
 * backend/hera-api/src/hera_api/services/auto_generated_questions.py
 */

export interface AutoGeneratedQuestion {
  text: string;
  answer_type: string;
  display_order: number;
}

export interface AutoGeneratedQuestions {
  number_of_units: AutoGeneratedQuestion;
  property_structure: AutoGeneratedQuestion;
  commercial_managed_property: AutoGeneratedQuestion;
  inspection_exemption: AutoGeneratedQuestion;
  vacancy: AutoGeneratedQuestion;
}

// Single source of truth for all auto-generated question texts
export const AUTO_GENERATED_QUESTIONS: AutoGeneratedQuestions = {
  number_of_units: {
    text: "How many rental dwelling units are located on the property?",
    answer_type: "number",
    display_order: 20,
  },
  property_structure: {
    text: "What is the property structure?",
    answer_type: "single_select",
    display_order: 10,
  },
  commercial_managed_property: {
    text: "Is this a commercial property under contract with property management services?",
    answer_type: "boolean",
    display_order: 20,
  },
  inspection_exemption: {
    text: "If you are claiming an inspection exemption based on the age of the building (less than five years old), please provide the date the building was completed. If you are not claiming an exemption, leave this field blank.",
    answer_type: "date",
    display_order: 20,
  },
  vacancy: {
    text: "Is the property vacant?",
    answer_type: "boolean",
    display_order: 50,
  },
};

// Backward compatibility: array of question texts for easy checking
const AUTO_GENERATED_QUESTION_TEXTS = [
  AUTO_GENERATED_QUESTIONS.number_of_units.text,
  AUTO_GENERATED_QUESTIONS.property_structure.text,
  AUTO_GENERATED_QUESTIONS.commercial_managed_property.text,
  AUTO_GENERATED_QUESTIONS.inspection_exemption.text,
  AUTO_GENERATED_QUESTIONS.vacancy.text,
] as const;

/**
 * Check if a question text matches any auto-generated question text (case-insensitive, trimmed).
 */
export function isAutoGeneratedQuestion(questionText: string): boolean {
  const normalized = questionText.trim().toLowerCase();
  return AUTO_GENERATED_QUESTION_TEXTS.some(
    (autoQuestion) => autoQuestion.trim().toLowerCase() === normalized,
  );
}
